<template>

    <div class="relative rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#0d1117] transition-all focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent">
        <textarea
            ref="inputField"
            :id="opts.id"
            :name="name"
            :placeholder="placeholder"
            :maxlength="maxlength"
            :value="value"
            :disabled="disabled"
            :readonly="readonly"
            :required="required"
            :rows="rows"
            :class="inputClasses"
            class="peer m-0 block w-full hidden-scroll bg-transparent text-sm px-4 pb-4 pt-6 leading-tight text-gray-900 dark:text-gray-100 placeholder:text-transparent border-none focus:ring-0 focus:outline-none resize-none disabled:cursor-not-allowed"
        ></textarea>

        <label :for="opts.id"
               class="pointer-events-none absolute left-0 top-0 origin-[0_0] px-4 pt-[15px] text-sm text-gray-400 dark:text-gray-500 transition-all duration-200 ease-linear peer-focus:-translate-y-2 peer-focus:translate-x-[0.15rem] peer-focus:scale-[0.75] peer-focus:text-blue-600 peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:scale-[0.75]">
            {{ placeholder }}
        </label>
    </div>

</template>

<script>
import Constants from "controllers/vue_components/mixins/constants";
export default {
    name: 'TimelydoTextArea',
    mixins: [Constants],
    props: [ 'name', 'placeholder', 'value', 'inputClasses', 'labelClasses', 'rows', 'opts'],
    data() {
        return {
            readonly: this.opts.readonly || false,
            disabled: this.opts.disabled || false,
            required: this.opts.required || false,
            maxlength: this.opts.maxlength || null,
        };
    },
};
</script>
